import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';
@Injectable({
  providedIn: 'root'
})
export class EncryptionDecryptionService {
  tokenFromUI: string = "MEwg6hCEgi1kmcJtTx00HK4Ao8MSMkQsShIhbkycWW05Z9VUQFBgFIIAwWfOGz2N";
  token_iv = "VjDZQjz6iKVgOPJk";
  constructor() { }
//will return encrypted text i.e of type string
  encryptUsingCrypto(message:any) {
    let _key = CryptoJS.enc.Hex.parse(this.tokenFromUI);
    let _iv = CryptoJS.enc.Hex.parse(this.token_iv);
    let encrypted = CryptoJS.TripleDES.encrypt(
      message, _key, {
      iv: _iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    }).toString();
   return encrypted;
  }
//will return decrypted text i.e of type string
  decryptUsingCrypto(message:any) {
   let _key = CryptoJS.enc.Hex.parse(this.tokenFromUI);
   let _iv = CryptoJS.enc.Hex.parse(this.token_iv);
   let decrypted = CryptoJS.TripleDES.decrypt(message, _key, {
      iv: _iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    }).toString(CryptoJS.enc.Utf8);
    return decrypted;
  }
  //will return encrypted object
  encryptObject(message:any){
    return  this.encryptUsingCrypto(JSON.stringify(message));
  }
  //will return decrypted object
  decryptObject(message:any){
    return JSON.parse(this.decryptUsingCrypto(message));
  }
}